import type { PageId } from "@lib/infrastructure";

export const HERE_AND_NOW_TABS = ["rooms", "workspaces", "explore"] as const;

export type HereAndNowTab = (typeof HERE_AND_NOW_TABS)[number];

export const HERE_AND_NOW_TAB_PAGE_IDS = {
  rooms: "hereAndNowRooms",
  workspaces: "hereAndNowWorkspaces",
  explore: "hereAndNowExplore",
} as const satisfies Record<HereAndNowTab, PageId>;

type TabAvailability = {
  meetingsCalendar: boolean;
  occupancy: boolean;
  workspacesOnHaN: boolean;
};

export const getAvailableTabs = ({ meetingsCalendar, occupancy, workspacesOnHaN }: TabAvailability) => {
  return HERE_AND_NOW_TABS.filter(tab => {
    switch (tab) {
      case "rooms":
        return meetingsCalendar || occupancy;
      case "workspaces":
        return workspacesOnHaN;
      case "explore":
        return true;
    }
  });
};

export type HaNTabRoute = { tab: HereAndNowTab } | { redirectTo: HereAndNowTab };

// Explore is the always-available fallback
export const resolveTabRoute = (requestedTab: string | undefined, availableTabs: HereAndNowTab[]): HaNTabRoute => {
  const tab = availableTabs.find(availableTab => availableTab === requestedTab);

  return tab ? { tab } : { redirectTo: availableTabs.at(0) ?? "explore" };
};
